import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { generatePath } from 'react-router-dom';
import { Country, Pagination, Response } from '@ui/src';
import { geographicalRiskApi } from '../services';
import ROUTES from '../../../../routes';

export interface GeographicalRiskState {
  document?: File;
  uploadSuccess?: boolean;
  sort?: {
    sortProp: string;
    sortDir: string;
  };
  country?: Country;
  uploadInProgress: boolean;
  values?: Country[];
  pagination?: Pagination;
  errorsList?: string;
}

const initialState: GeographicalRiskState = {
  uploadInProgress: false,
};

export const geographicalRiskSlice = createSlice({
  name: 'geographicalRisk',
  initialState,
  reducers: {
    onFileUpload: (state, action: PayloadAction<File>) => {
      state.uploadInProgress = true;
      state.document = action.payload;
      state.uploadSuccess = false;
    },
    onFileUploadSuccess: (state) => {
      state.uploadInProgress = false;
      state.uploadSuccess = true;
      state.document = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        geographicalRiskApi.endpoints.getAmlCountries.matchPending,
        (state) => {
          state.errorsList = undefined;
        },
      )
      .addMatcher(
        geographicalRiskApi.endpoints.getAmlCountries.matchRejected,
        (state, action: any) => {
          state.values = undefined;
          state.pagination = undefined;

          if (action?.payload.data) {
            if (Array.isArray(action?.payload.data?.message)) {
              state.errorsList = action?.payload.data?.message
                ?.map((item: { value: string }) => item.value)
                .join('; ');
            } else {
              state.errorsList = action?.payload.data?.error;
            }
          }
        },
      )
      .addMatcher(
        geographicalRiskApi.endpoints.getAmlCountries.matchFulfilled,
        (state, action: PayloadAction<Response<Country>>) => {
          state.values = action.payload.data.edges.map((item) => ({
            ...item.node,
            url: generatePath(ROUTES.GEOGRAPHICAL_ITEM, {
              id: item.node.id,
            }),
          }));
          state.pagination = action.payload.data.pageInfo;
        },
      )
      .addMatcher(
        geographicalRiskApi.endpoints.getGeographialRisk.matchFulfilled,
        (state, action: PayloadAction<{ data: Country }>) => {
          state.country = action.payload.data;
        },
      )
      .addMatcher(
        geographicalRiskApi.endpoints.updateGeographicalRiskScore
          .matchFulfilled,
        (state, action: PayloadAction<{ data: Country }>) => {
          state.values = state.values?.map((item) => {
            const result = { ...item };

            if (result.id === action.payload.data.id) {
              result.riskScore = action.payload.data.riskScore;
            }

            return result;
          });

          state.country = action.payload.data;
        },
      );
  },
});

export const { onFileUpload, onFileUploadSuccess } =
  geographicalRiskSlice.actions;

export default geographicalRiskSlice.reducer;
